import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { GuestComponent } from './theme/layout/guest/guest.component';
import { rbacGuard } from './guards/rbac.guard';

const routes: Routes = [
  {
    path: 'qa-legal-guardian-preview',
    loadComponent: () => import('./demo/referralDetails/tabs/qa-legal-guardian-preview.component').then((m) => m.QaLegalGuardianPreviewComponent)
  },
  {
    // No layout and no guard — reached via the axios interceptor / startup check in
    // AppModule's APP_INITIALIZER whenever the API reports maintenance.
    path: 'maintenance',
    loadComponent: () => import('./demo/pages/maintenance/maintenance.component')
  },
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./demo/dashboard/dashboard.component')
      },
      {
        path: 'dashboard-analytics',
        loadComponent: () => import('./demo/dashboardAnalytics/dashboard-analytics.component')
      },
      {
        path: 'BotQueue/Index',

        loadComponent: () => import('./demo/referral/referral-files.component'),
        pathMatch: 'prefix'
      },
      {
        path: 'BotQueue/Details',
        loadComponent: () => import('./demo/detailsfilelist/details-file-list.component')
      },
      {
        path: 'documents-received',
        loadComponent: () => import('./demo/documentsReceived/documents-received.component')
      },

      {
        path: 'BotQueue/ExceptionDetails',
        loadComponent: () => import('./demo/exceDetailFiles/exce-details-file.component')
      },
      {
        path: 'BotQueue/ExceptionPageDetails',
        loadComponent: () => import('./demo/exceDetailsPage/exce-page-details.component')
      },
      {
        path: 'pageException',
        loadComponent: () => import('./demo/pageException/page-exception.component')
      },
      {
        path: 'acc-info',
        loadComponent: () => import('./demo/accountInfo/acc-info.component')
      },
      {
        path: 'miscellanous-page',
        loadComponent: () => import('./demo/miscellanousPage/miscellanous-page.component')
      },
      {
        path: 'user-list',
        canActivate: [rbacGuard],
        // TODO: drop 'User' once a real SystemAdmin/Administrator account exists — temporary
        // so RBAC management is reachable before that seed data exists.
        data: { roles: ['SystemAdmin', 'Administrator', 'User'] },
        loadComponent: () => import('./demo/reports/user-list/user-list.component')
      },
      {
        path: 'page-entities-admin',
        canActivate: [rbacGuard],
        data: { roles: ['SystemAdmin', 'Administrator'] },
        loadComponent: () => import('./demo/pageEntitiesAdmin/page-entities-admin.component')
      },
      {
        path: 'page-layout',
        canActivate: [rbacGuard],
        data: { roles: ['SystemAdmin', 'Administrator'] },
        loadComponent: () => import('./demo/pageLayout/page-layout.component')
      },
      {
        path: 'tenant-config',
        canActivate: [rbacGuard],
        data: { roles: ['SystemAdmin', 'Administrator'] },
        loadComponent: () => import('./demo/tenantConfig/tenant-config.component')
      },
      {
        path: 'keyword-management',
        canActivate: [rbacGuard],
        data: { roles: ['SystemAdmin', 'Administrator'] },
        loadComponent: () => import('./demo/keywordManagement/keyword-management.component')
      },
      {
        path: 'access-denied',
        loadComponent: () => import('./demo/pages/access-denied/access-denied.component')
      },
      {
        path: 'incoming-referral',
        loadComponent: () => import('./demo/incomingReferral/incoming-referral.component')
      },
      {
        path: 'referral-details/:referralId',
        loadComponent: () => import('./demo/referralDetails/referral-details.component')
      },
      {
        path: 'referral-details/:documentId/:referralId',
        loadComponent: () => import('./demo/referralDetails/referral-details.component')
      },
      {
        path: 'web-referral',
        loadComponent: () => import('./demo/webReferral/web-referral.component')
      },
      {
        path: 'web-referral/:id',
        loadComponent: () => import('./demo/webReferral/web-referral.component')
      },
      {
        path: 'build-referral',
        loadComponent: () => import('./demo/buildReferral/build-referral.component')
      },
      {
        path: 'workflow-summary',
        loadComponent: () => import('./demo/workflowSummary/workflow-summary.component')
      },
      {
        path: 'exception-queue',
        loadComponent: () => import('./demo/exceptionQueue/exception-queue.component')
      },
      {
        path: 'non-referrals',
        loadComponent: () => import('./demo/nonReferrals/non-referrals.component')
      },
      {
        path: '',
        // DOCUMENTS_RECEIVED_HOME — Documents Received > Manual Review Docs.
        redirectTo: '/documents-received?status=manual_review_docs',
        pathMatch: 'full'
      }
      // {
      //   path: 'dashboard',
      //   loadComponent: () => import('./demo/dashboard/dashboard.component')
      // }
      // {
      //   path: 'dashboard/:reportid',
      //   loadComponent: () => import('./demo/default/default.component').then((c) => c.DefaultComponent)
      // },
      // {
      //   path: 'dashboard/:reportid/:abbr',
      //   loadComponent: () => import('./demo/default/default.component').then((c) => c.DefaultComponent)
      // },
      // {
      //   path: 'typography',
      //   loadComponent: () => import('./demo/elements/typography/typography.component')
      // },
      // {
      //   path: 'color',
      //   loadComponent: () => import('./demo/elements/element-color/element-color.component')
      // }
      // {
      //   path: 'sample-page',
      //   loadComponent: () => import('./demo/sample-page/sample-page.component')
      // },
      // {
      //   path: 'client-list',
      //   loadComponent: () => import('./demo/reports/client-list/client-list.component')
      // },
      // {
      //   path: 'role-list',
      //   loadComponent: () => import('./demo/reports/role/role.component')
      // },
      // {
      //   path: 'activity-log',
      //   loadComponent: () => import('./demo/reports/activity-log/activity-log.component')
      // },
      // {
      //   path: 'report-list',
      //   loadComponent: () => import('./demo/reports/report-list/report-list.component')
      // }
    ]
  },
  {
    path: '',
    component: GuestComponent,
    children: [
      {
        path: 'guest',
        loadChildren: () => import('./demo/pages/authentication/authentication.module').then((m) => m.AuthenticationModule)
      }
    ]
  },
  { path: '**', redirectTo: '/guest/login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
